export default __webpack_public_path__ + "static/media/already_reject.cb13d4b7.png";